import React from 'react';
import styles from './Card.module.scss';
import clsx from 'clsx';

type CardProps = {
  children: React.ReactNode;
  rounded?: boolean;
  className?: string;
  isTransparent?: boolean;
  isNoLeftPadding?: boolean;
  style?: {};
  onClick?: () => void;
};

const Card: React.FC<CardProps> = ({
  children,
  className,
  rounded = true,
  isTransparent,
  isNoLeftPadding,
  style,
  onClick,
}) => {
  return (
    <div
      style={style}
      onClick={onClick}
      className={clsx(className, styles.card, {
        [styles.rounded]: rounded,
        [styles.transparent]: isTransparent,
        [styles.isNoLeftPadding]: isNoLeftPadding,
      })}
    >
      {children}
    </div>
  );
};

export default Card;
